export default {
  lang: 'de',
  dir: 'ltr',
  common: {
    ok: 'OK',
    cancel: 'Abbrechen',
    key_backspace: 'Rücktaste',
    key_del: 'Löschen',
    key_down: 'nach unten',
    key_up: 'nach oben',
    more_opts: 'Mehr Optionen',
    url: 'URL',
    width: 'Breite',
    height: 'Höhe'
  },
  misc: {
    powered_by: 'powered by'
  },
  ui: {
    toggle_stroke_tools: 'Zeige/Verberge weitere Linien-Werkzeuge',
    palette_info: 'Klick zum Ändern der Füllfarbe, Shift-Klick zum Ändern der Linienfarbe',
    zoom_level: 'vergrößern',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Element identifizieren',
    fill_color: 'Füllfarbe ändern',
    stroke_color: 'Linienfarbe ändern',
    stroke_style: 'Linienstil ändern',
    stroke_width: 'Linienbreite ändern',
    pos_x: 'Ändere die X-Koordinate',
    pos_y: 'Ändere die Y-Koordinate',
    linecap_butt: 'Form der Linienendung: Stumpf',
    linecap_round: 'Form der Linienendung: Rund',
    linecap_square: 'Form der Linienendung: Rechteckig',
    linejoin_bevel: 'Zusammentreffen von zwei Linien: abgeschrägte Kante',
    linejoin_miter: 'Zusammentreffen von zwei Linien: Gehrung',
    linejoin_round: 'Zusammentreffen von zwei Linien: Rund',
    angle: 'Drehwinkel ändern',
    blur: 'Ändere Wert des Gaußschen Weichzeichners',
    opacity: 'Opazität des ausgewählten Objekts ändern',
    circle_cx: 'Kreiszentrum (cx) ändern',
    circle_cy: 'Kreiszentrum (cy) ändern',
    circle_r: 'Kreisradius (r) ändern',
    ellipse_cx: 'Ellipsenzentrum (cx) ändern',
    ellipse_cy: 'Ellipsenzentrum (cy) ändern',
    ellipse_rx: 'Ellipsenradius (x) ändern',
    ellipse_ry: 'Ellipsenradius (y) ändern',
    line_x1: 'X-Koordinate des Linienanfangs ändern',
    line_x2: 'X-Koordinate des Linienendes ändern',
    line_y1: 'Y-Koordinate des Linienanfangs ändern',
    line_y2: 'Y-Koordinate des Linienendes ändern',
    rect_height: 'Höhe des Rechtecks ändern',
    rect_width: 'Breite des Rechtecks ändern',
    corner_radius: 'Eckenradius des Rechtecks ändern',
    image_width: 'Bildbreite ändern',
    image_height: 'Bildhöhe ändern',
    image_url: 'URL ändern',
    node_x: 'Ändere die X-Koordinate des Knoten',
    node_y: 'Ändere die Y-Koordinate des Knoten',
    seg_type: 'Ändere den Typ des Segments',
    straight_segments: 'Gerade',
    curve_segments: 'Kurve',
    text_contents: 'Textinhalt erstellen und bearbeiten',
    font_family_label: 'Font:',
    font_family: 'Schriftart wählen',
    font_size: 'Schriftgröße einstellen',
    bold: 'Fetter Text',
    italic: 'Kursiver Text',
    text_anchor_start: 'Den Text linksbündig ausrichten',
    text_anchor_middle: 'Den Text zentriert ausrichten',
    text_anchor_end: 'Den Text rechtsbündig ausrichten',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Hauptmenü',
    bkgnd_color_opac: 'Hintergrundfarbe ändern / Opazität',
    connector_no_arrow: 'Kein Pfeil',
    fitToContent: 'An den Inhalt anpassen',
    fit_to_all: 'An gesamten Inhalt anpassen',
    fit_to_canvas: 'An die Zeichenfläche anpassen',
    fit_to_layer_content: 'An Inhalt der Ebene anpassen',
    fit_to_sel: 'An die Auswahl anpassen',
    align_relative_to: 'Relativ zu einem anderem Objekt ausrichten …',
    relativeTo: 'im Vergleich zu:',
    page: 'Seite',
    largest_object: 'größtes Objekt',
    selected_objects: 'gewählte Objekte',
    smallest_object: 'kleinstes Objekt',
    new_doc: 'Neues Bild',
    open_doc: 'Bild öffnen',
    export_img: 'Export',
    save_doc: 'Bild speichern',
    import_doc: 'Importiere SVG',
    align_to_page: 'Element an Seite ausrichten',
    align_bottom: 'Unten ausrichten',
    align_center: 'Zentriert ausrichten',
    align_left: 'Linksbündig ausrichten',
    align_middle: 'In der Mitte ausrichten',
    align_right: 'Rechtsbündig ausrichten',
    align_top: 'Oben ausrichten',
    mode_select: 'Objekte auswählen und verändern',
    mode_fhpath: 'Freihandlinien zeichnen',
    mode_line: 'Linien zeichnen',
    mode_rect: 'Rechteck-Werkzeug',
    mode_square: 'Quadrat-Werkzeug',
    mode_fhrect: 'Freihand-Rechteck',
    mode_ellipse: 'Ellipse',
    mode_circle: 'Kreis',
    mode_fhellipse: 'Freihand-Ellipse',
    mode_path: 'Pfad zeichnen',
    mode_text: 'Text erstellen und bearbeiten',
    mode_image: 'Bild einfügen',
    mode_zoom: 'Zoomfaktor vergrößern oder verringern',
    no_embed: 'Hinweis: Dieses Bild kann nicht eingebettet werden. Eine Anzeige hängt von diesem Pfad ab.',
    undo: 'Rückgängig',
    redo: 'Wiederherstellen',
    tool_source: 'Quellcode bearbeiten',
    wireframe_mode: 'Drahtmodell-Modus',
    clone: 'Element(e) klonen',
    del: 'Element(e) löschen',
    group_elements: 'Element(e) gruppieren',
    make_link: 'Link erstellen',
    set_link_url: 'Link setzen (leer lassen zum Entfernen)',
    to_path: 'Gewähltes Objekt in einen Pfad konvertieren',
    reorient_path: 'Neuausrichtung des Pfades',
    ungroup: 'Gruppierung aufheben',
    docprops: 'Dokument-Eigenschaften',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Die gewählten Objekte nach ganz unten verschieben',
    move_top: 'Die gewählten Objekte nach ganz oben verschieben',
    node_clone: 'Klone den Knoten',
    node_delete: 'Lösche den Knoten',
    node_link: 'Gekoppelte oder separate Kontrollpunkte für die Bearbeitung des Pfades',
    add_subpath: 'Teilpfad hinzufügen',
    openclose_path: 'Öffne/Verbinde Unterpfad',
    source_save: 'Änderungen akzeptieren',
    cut: 'Ausschneiden',
    copy: 'Kopieren',
    paste: 'Einfügen',
    paste_in_place: 'Bei Originalposition einfügen',
    delete: 'Löschen',
    group: 'Gruppieren',
    move_front: 'Nach ganz oben verschieben',
    move_up: 'Hochschieben',
    move_down: 'Herunterschieben',
    move_back: 'Nach ganz unten verschieben',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Ebene',
    layers: 'Ebenen',
    del: 'Ebene löschen',
    move_down: 'Ebene nach unten verschieben',
    new: 'Neue Ebene',
    rename: 'Ebene umbenennen',
    move_up: 'Ebene nach oben verschieben',
    dupe: 'Ebene duplizieren',
    merge_down: 'Nach unten zusammenführen',
    merge_all: 'Alle zusammenführen',
    move_elems_to: 'Verschiebe ausgewählte Objekte:',
    move_selected: 'Verschiebe ausgewählte Objekte auf eine andere Ebene'
  },
  config: {
    image_props: 'Bildeigenschaften',
    doc_title: 'Titel',
    doc_dims: 'Dimension der Zeichenfläche',
    included_images: 'Eingefügte Bilder',
    image_opt_embed: 'Daten einbetten (lokale Dateien)',
    image_opt_ref: 'Benutze die Dateireferenz',
    editor_prefs: 'Editor-Einstellungen',
    language: 'Sprache',
    background: 'Editor-Hintergrund',
    editor_img_url: 'Bild-URL',
    editor_bg_note: 'Anmerkung: Der Hintergrund wird mit dem Bild nicht gespeichert.',
    select_predefined: 'Auswahl einer vordefinierten:',
    units_and_rulers: 'Einheiten und Lineale',
    show_rulers: 'Zeige Lineale',
    base_unit: 'Basiseinheit:',
    grid: 'Gitternetz',
    snapping_onoff: 'Einrasten an/aus',
    snapping_stepsize: 'Einrastabstand:',
    grid_color: 'Gitterfarbe',
    done: "Done",
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Fehlerhafter Wert',
    noContentToFitTo: 'Kein Inhalt anzupassen',
    dupeLayerName: 'Eine Ebene hat bereits diesen Namen',
    enterUniqueLayerName: 'Verwenden Sie einen eindeutigen Namen für die Ebene',
    enterNewLayerName: 'Geben Sie bitte einen neuen Namen für die Ebene ein',
    layerHasThatName: 'Eine Ebene hat bereits diesen Namen',
    QmoveElemsToLayer: "Verschiebe ausgewählte Objekte in die Ebene '%s'?",
    QwantToClear: 'Möchten Sie die Zeichnung löschen?\nDadurch wird auch die Rückgängig-Funktion zurückgesetzt!',
    QwantToOpen: 'Möchten Sie eine neue Datei öffnen?\nDadurch wird auch die Rückgängig-Funktion zurückgesetzt!',
    QerrorsRevertToSource: 'Es gibt Parser-Fehler in der SVG-Quelle.\nDie Original-SVG wiederherstellen?',
    QignoreSourceChanges: 'Sollen die Änderungen an der SVG-Quelle ignoriert werden?',
    featNotSupported: 'Diese Eigenschaft wird nicht unterstützt',
    enterNewImgURL: 'Geben Sie die URL für das neue Bild an',
    defsFailOnSave: 'Hinweis: Aufgrund eines Fehlers in Ihrem Browser kann dieses Bild falsch angezeigt werden (fehlende Gradienten oder Elemente). Es wird jedoch richtig angezeigt, sobald es gespeichert wird.',
    loadingImage: 'Bild wird geladen, bitte warten ...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Beachten Sie außerdem die folgenden Probleme: ',
    unsavedChanges: 'Es sind nicht-gespeicherte Änderungen vorhanden.',
    enterNewLinkURL: 'Geben Sie die neue URL ein',
    errorLoadingSVG: 'Fehler: Kann SVG-Daten nicht laden',
    URLLoadFail: 'Kann von dieser URL nicht laden',
    retrieving: "Retrieving '%s' ...",
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
};
